import { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ekinIcon = L.divIcon({
  className: "ekin-multi-marker",
  html: `<span style="background:#1A3A8C;display:block;width:14px;height:14px;border-radius:50%;border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.35)"></span>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -9],
});

/** Renders a map with multiple delivery destination markers. */
export default function MultiPointMap({ points, height = 360 }) {
  const validPoints = useMemo(
    () => (points || []).filter((p) => typeof p.lat === "number" && typeof p.lng === "number"),
    [points]
  );

  if (validPoints.length === 0) {
    return (
      <div className="border border-zinc-200 bg-zinc-50 p-8 text-center text-sm text-zinc-500" style={{ height }}>
        Sin puntos GPS para mostrar todavía.
      </div>
    );
  }

  // Center on average; let bounds zoom in
  const lats = validPoints.map((p) => p.lat);
  const lngs = validPoints.map((p) => p.lng);
  const center = [(Math.min(...lats) + Math.max(...lats)) / 2, (Math.min(...lngs) + Math.max(...lngs)) / 2];
  const bounds = validPoints.length > 1 ? validPoints.map((p) => [p.lat, p.lng]) : undefined;

  const fmt = (iso) => {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
    } catch { return iso; }
  };

  return (
    <div className="border border-zinc-200 overflow-hidden" style={{ height }} data-testid="multi-point-map">
      <MapContainer
        center={center}
        zoom={validPoints.length === 1 ? 12 : undefined}
        bounds={bounds}
        boundsOptions={{ padding: [30, 30] }}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {validPoints.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={ekinIcon}>
            <Popup>
              <div className="text-xs">
                <p className="font-semibold">{p.cliente}</p>
                <p className="text-zinc-500 mt-1">{fmt(p.entregado_at)}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
